import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import http from "infra/http";
import { useState, useCallback } from "react";
import { useProcessamentoModal } from "components/DrawerProcessamentos/ProcessamentoModalContext";

export function useGerarBoleto({
  mes,
  ano,
  selectedArrecadacoesIds,
}: {
  mes: string;
  ano: string;
  selectedArrecadacoesIds?: string[];
}) {
  const { onOpen: onOpenProcessamentoModal } = useProcessamentoModal();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = useCallback(
    async (params?: {
      incluirDemonstrativo?: boolean;
      dataInicioDemonstrativo?: string;
      dataFimDemonstrativo?: string;
      contasBancarias?: "todas" | "somenteDaCobranca";
    }) => {
      try {
        setIsLoading(true);

        const { data } = await http.post<{ taskId: string }>(
          `v1/arrecadacao/${mes}/${ano}/processar`,
          {
            arrecadacoesIds: selectedArrecadacoesIds,
            ...params,
          }
        );

        await showSuccess(
          data.taskId
            ? `O processamento ${
                selectedArrecadacoesIds?.length === 1
                  ? "da arrecadação"
                  : "das arrecadações"
              } continuará em segundo plano`
            : undefined
        );
        if (data.taskId) {
          onOpenProcessamentoModal();
        }
      } catch (error) {
        await showErrorAxios(error);
      } finally {
        setIsLoading(false);
      }
    },
    [mes, ano, selectedArrecadacoesIds, onOpenProcessamentoModal]
  );

  return {
    isLoading,
    handleClick,
  };
}
